<mc-dialog (closeEvent)="close()">
  <div class="confirm-dialog">
    <div class="dialog-title">
      <mat-icon class="icon" svgIcon="site"></mat-icon>
      <p>{{ sites.length }} sites will be affected by this change</p>
    </div>
    <div class="dialog-info">
      <p class="subheader">These include:</p>
      <p>
        <span>{{ sitesList }}</span>
        @if (showMoreInfo) {
          <span>...</span>
        } @else {
          <span>.</span>
        }
        @if (showMoreInfo) {
          <span>
            and
            <span class="count"> {{ restCountOfSites }} {{ restCountOfSites | plural: 'other' : 'others' }}</span
            >.
          </span>
        }
      </p>
      <p>Are you sure you want to proceed?</p>
    </div>
    <div class="dialog-actions">
      <mc-button (click)="close()" variant="stroked" color="primary">Cancel</mc-button>
      <mc-button (click)="confirm()" variant="flat" color="primary">Apply to all {{ sites.length }} sites</mc-button>
    </div>
  </div>
</mc-dialog>
